import { render } from "./CopyPosSettingsToBranches.vue?vue&type=template&id=0e59de8d&scoped=true"
import script from "./CopyPosSettingsToBranches.vue?vue&type=script&lang=js"
export * from "./CopyPosSettingsToBranches.vue?vue&type=script&lang=js"

import "./CopyPosSettingsToBranches.vue?vue&type=style&index=0&id=0e59de8d&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e59de8d"]])

export default __exports__